import Login from './Login'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function(Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(Login)

    //2.用new 的方式用组件构造器创建出来组件对象
    const login = new Construct({ router, store })

    //3.将组件对象手动挂载到某一个元素上
    login.$mount(document.createElement('div'))

    //4.login.$el对应的就是div
    document.body.appendChild(login.$el)

    //5.在原型中加入Login
    Vue.prototype.$Login = login
}

export default obj
